import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import { AppRoot } from "@telegram-apps/telegram-ui";
import "@telegram-apps/telegram-ui/dist/styles.css";

import { App } from "./App";
import { AppDataProvider } from "./AppData";
import { AuthProvider, useAuth } from "./AuthProvider";
import { LoginPage } from "./pages/LoginPage";
import { WebChromeProvider } from "./webChrome";
import "./styles.css";

/** В вебе без сессии показываем экран входа; в Mini App — сразу приложение. */
function AuthGate({ children }: { children: React.ReactNode }) {
  const { mode, authenticated } = useAuth();
  if (mode === "web" && !authenticated) return <LoginPage />;
  return <>{children}</>;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AppRoot className="app-root">
      <HashRouter>
        <AuthProvider>
          <AuthGate>
            <AppDataProvider>
              <WebChromeProvider>
                <App />
              </WebChromeProvider>
            </AppDataProvider>
          </AuthGate>
        </AuthProvider>
      </HashRouter>
    </AppRoot>
  </React.StrictMode>,
);
